import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  Dropdown,
  Button,
  ButtonGroup,
  Accordion,
  Card,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TfiMenu } from "react-icons/tfi";
import { Sidebar } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { IoMdAnalytics } from "react-icons/io";
import { IoIosCreate } from "react-icons/io";
import { PiListPlusFill } from "react-icons/pi";
import { RiUserAddFill } from "react-icons/ri";
import { PiUserListBold } from "react-icons/pi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { LiaClipboardListSolid } from "react-icons/lia";
import { GiExpense } from "react-icons/gi";
import { RiCurrencyFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { logout } from "../features/user/userSlice";
import { HiArchive } from "react-icons/hi";
import { MdPhonelinkSetup } from "react-icons/md";
import { FaClipboardList } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";
import { GiTakeMyMoney } from "react-icons/gi";
import { MdOutlinePlaylistAddCheck } from "react-icons/md";
import { RiSecurePaymentFill } from "react-icons/ri";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [toggled, setToggled] = React.useState(false);

  const [permissions, setPermissions] = useState([]);

  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    if (userInfo && Array.isArray(userInfo.permissions)) {
      setPermissions(userInfo.permissions);
    }
  }, [userInfo]);

  // console.log("permissions", permissions);
  // console.log("userInfo", userInfo);
  // console.log("user permissions", userInfo.permissions);

  // const hasPermissions = userInfo.permissions ? userInfo.permissions : false;

  const hasAnalyticsPermissions = permissions.includes("analytics");
  const hasCreatePassportPermissions = permissions.includes("createPassport");
  const hasPassportListPermissions = permissions.includes("passportList");
  const hasDueCollectionListPermissions =
    permissions.includes("dueCollectionList");
  const hasCreateVisaPermissions = permissions.includes("createVisa");
  const hasVisaListPermissions = permissions.includes("visaList");
  const hasCreateAgentPermissions = permissions.includes("createAgent");
  const hasAgentListPermissions = permissions.includes("agentList");
  const hasCreateEmployeePermissions = permissions.includes("createEmployee");
  const hasEmployeeListPermissions = permissions.includes("employeeList");
  const hasCreateDeliveryOfficePermissions = permissions.includes(
    "createDeliveryOffice"
  );
  const hasDeliveryOfficeListPermissions =
    permissions.includes("deliveryOfficeList");
  const hasDailyExpenseEntryPermissions =
    permissions.includes("dailyExpenseEntry");
  const hasDailyExpensePermissions = permissions.includes("dailyExpense");
  const hasTotalMonthlyExpensePermissions = permissions.includes(
    "totalMonthlyExpenses"
  );
  const hasSalaryEntryPermissions = permissions.includes("salaryEntry");
  const hasSalaryExpensePermissions = permissions.includes("salaryExpense");
  const hasIncomeEntryPermissions = permissions.includes("incomeEntry");
  const hasIncomeScreenPermissions = permissions.includes("incomeScreen");

  // console.log("Analytics Permission", hasAnalyticsPermissions);

  // Sidenav options
  const analyticsOption = hasAnalyticsPermissions && (
    <>
      {/* <Accordion.Body> */}
      <Link
        to="/"
        style={{
          textDecoration: "none",
          color: "black",
          fontWeight: "bold",
        }}
      >
        <IoMdAnalytics className="mb-1" size="20" /> Analytics
      </Link>
      {/* </Accordion.Body> */}
    </>
  );

  const passportOptions = (
    <>
      {hasCreatePassportPermissions && (
        <Accordion.Body>
          <Link
            to="/createPassport"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <IoIosCreate size="20" /> Create Passport
          </Link>
        </Accordion.Body>
      )}

      {hasPassportListPermissions && (
        <Accordion.Body>
          <Link
            to="/passportList"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <PiListPlusFill size="20" /> Passport List
          </Link>
        </Accordion.Body>
      )}

      {hasDueCollectionListPermissions && (
        <Accordion.Body>
          <Link
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
            to="/dueCollectionList"
          >
            {" "}
            <HiArchive size="20" /> Due Collection
          </Link>
        </Accordion.Body>
      )}
    </>
  );

  const visaOptions = (
    <>
      {hasCreateVisaPermissions && (
        <Accordion.Body>
          <Link
            to="/createVisa"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <RiUserAddFill size="20" /> Create Visa
          </Link>
        </Accordion.Body>
      )}

      {hasVisaListPermissions && (
        <Accordion.Body>
          <Link
            to="/VisaList"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <PiUserListBold size="20" /> Visa List
          </Link>
        </Accordion.Body>
      )}
    </>
  );

  const agentOptions = (
    <>
      {hasCreateAgentPermissions && (
        <Accordion.Body>
          <Link
            to="/createAgent"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <RiUserAddFill size="20" /> Create Agent
          </Link>
        </Accordion.Body>
      )}

      {hasAgentListPermissions && (
        <Accordion.Body>
          <Link
            to="/AgentList"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <PiUserListBold size="20" /> Agent List
          </Link>
        </Accordion.Body>
      )}
    </>
  );

  const officeAgentOptions = (
    <>
      {hasCreateEmployeePermissions && (
        <Accordion.Body>
          <Link
            to="/createOfficeAgent"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <RiUserAddFill size="20" /> Create Office Agent
          </Link>
        </Accordion.Body>
      )}

      {hasEmployeeListPermissions && (
        <Accordion.Body>
          <Link
            to="/officeAgentList"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <PiUserListBold size="20" /> Office Agent List
          </Link>
        </Accordion.Body>
      )}
    </>
  );

  const deliveryOfficeOptions = (
    <>
      {hasCreateDeliveryOfficePermissions && (
        <Accordion.Body>
          <Link
            to="/createDeliveryOffice"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <HiOutlineBuildingOffice2 size="20" /> Create Delivery Office
          </Link>
        </Accordion.Body>
      )}

      {hasDeliveryOfficeListPermissions && (
        <Accordion.Body>
          <Link
            to="/deliveryOfficeList"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <LiaClipboardListSolid size="20" /> Delivery Office List
          </Link>
        </Accordion.Body>
      )}
    </>
  );

  const accountsOptions = (
    <>
      {hasDailyExpenseEntryPermissions && (
        <Accordion.Body>
          <Link
            to="/dailyExpenseEntry"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <GiExpense size="20" /> Daily Expense Entry
          </Link>
        </Accordion.Body>
      )}
      {hasDailyExpensePermissions && (
        <Accordion.Body>
          <Link
            to="/dailyExpense"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <FaClipboardList size="20" /> Daily Expense List
          </Link>
        </Accordion.Body>
      )}

      {hasSalaryEntryPermissions && (
        <Accordion.Body>
          <Link
            to="/salaryEntry"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <GiReceiveMoney size="20" /> Salary Entry
          </Link>
        </Accordion.Body>
      )}
      {hasSalaryExpensePermissions && (
        <Accordion.Body>
          <Link
            to="/salaryExpense"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <MdOutlinePlaylistAddCheck size="20" /> Salary Expense List
          </Link>
        </Accordion.Body>
      )}

      {hasTotalMonthlyExpensePermissions && (
        <Accordion.Body>
          <Link
            to="/totalMonthlyExpenses"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <RiSecurePaymentFill size="20" /> Total Monthly Expense
          </Link>
        </Accordion.Body>
      )}

      {hasIncomeEntryPermissions && (
        <Accordion.Body>
          <Link
            to="/incomeEntry"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <GiTakeMyMoney size="20" />
            Income Entry
          </Link>
        </Accordion.Body>
      )}
      {hasIncomeScreenPermissions && (
        <Accordion.Body>
          <Link
            to="/incomeScreen"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
            }}
          >
            <RiCurrencyFill size="20" /> Income List
          </Link>
        </Accordion.Body>
      )}
    </>
  );

  const logoutHandler = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <>
      {/* <Navbar className="fixed-top px-2" style={{ backgroundColor: "#E1E1E1" }}> */}
      <Navbar className="fixed-top px-2" style={{ backgroundColor: "#c3d2e8" }}>
        <Container>
          <div className="SidebarMobile">
            <Sidebar
              onBackdropClick={() => setToggled(false)}
              toggled={toggled}
              breakPoint="always"
              style={{ backgroundColor: "white" }}
            >
              <Accordion flush>
                <Card.Text className="mt-3 ms-3">
                  {/* <IoMdAnalytics className="mb-1" size="20" />
            <Link
              to="/"
              style={{
                textDecoration: "none",
                color: "black",
                fontWeight: "bold",
              }}
            >
              {" "}
              Analytics
            </Link> */}
                  {analyticsOption}
                </Card.Text>

                <Accordion.Item eventKey="1" className="">
                  <Accordion.Header>
                    <strong style={{ color: "black" }}>Passport</strong>
                  </Accordion.Header>
                  {passportOptions}
                  {/* <Accordion.Body>
              <Link
                to="/createPassport"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <IoIosCreate size="20" /> Create Passport
              </Link>
            </Accordion.Body> */}

                  {/* <Accordion.Body>
              <Link
                to="/passportList"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <PiListPlusFill size="20" /> Passport List
              </Link>
            </Accordion.Body> */}

                  {/* <Accordion.Body>
              <Link
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
                to="/dueCollectionList"
              >
                {" "}
                <HiArchive size="20" /> Due Collection
              </Link>
            </Accordion.Body> */}

                  <Accordion.Item eventKey="6" className="">
                    <Accordion.Header style={{ fontWeight: "bold" }}>
                      <strong style={{ color: "black" }}>Visa</strong>
                    </Accordion.Header>
                    {visaOptions}
                  </Accordion.Item>
                </Accordion.Item>

                <Accordion.Item eventKey="2" className="">
                  <Accordion.Header style={{ fontWeight: "bold" }}>
                    <strong style={{ color: "black" }}>Agent</strong>
                  </Accordion.Header>
                  {agentOptions}
                  {/* <Accordion.Body>
              <Link
                to="/createAgent"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <RiUserAddFill size="20" /> Create Agent
              </Link>
            </Accordion.Body>
            <Accordion.Body>
              <Link
                to="/AgentList"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <PiUserListBold size="20" /> Agent List
              </Link>
            </Accordion.Body> */}
                </Accordion.Item>

                <Accordion.Item eventKey="3" className="">
                  <Accordion.Header style={{ fontWeight: "bold" }}>
                    <strong style={{ color: "black" }}>Office Agent</strong>
                  </Accordion.Header>
                  {officeAgentOptions}
                  {/* <Accordion.Body>
              <Link
                to="/createOfficeAgent"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <RiUserAddFill size="20" /> Create Office Agent
              </Link>
            </Accordion.Body>
            <Accordion.Body>
              <Link
                to="/officeAgentList"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <PiUserListBold size="20" /> Office Agent List
              </Link>
            </Accordion.Body> */}
                </Accordion.Item>

                <Accordion.Item eventKey="4" className="">
                  <Accordion.Header style={{ fontWeight: "bold" }}>
                    <strong style={{ color: "black" }}>Delivery Office</strong>
                  </Accordion.Header>
                  {deliveryOfficeOptions}
                  {/* <Accordion.Body>
              <Link
                to="/createDeliveryOffice"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <HiOutlineBuildingOffice2 size="20" /> Create Delivery Office
              </Link>
            </Accordion.Body>
            <Accordion.Body>
              <Link
                to="/deliveryOfficeList"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <LiaClipboardListSolid size="20" /> Delivery Office List
              </Link>
            </Accordion.Body> */}

                  <Accordion.Item eventKey="4" className="">
                    <Accordion.Header style={{ fontWeight: "bold" }}>
                      <strong style={{ color: "black" }}>
                        Delivery Office
                      </strong>
                    </Accordion.Header>
                    {deliveryOfficeOptions}
                    {/* <Accordion.Body>
              <Link
                to="/createDeliveryOffice"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <HiOutlineBuildingOffice2 size="20" /> Create Delivery Office
              </Link>
            </Accordion.Body>
            <Accordion.Body>
              <Link
                to="/deliveryOfficeList"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <LiaClipboardListSolid size="20" /> Delivery Office List
              </Link>
            </Accordion.Body> */}
                  </Accordion.Item>
                  
                </Accordion.Item>

                <Accordion.Item
                  eventKey="5"
                  className=""
                  style={{ borderRadius: "0" }}
                >
                  <Accordion.Header style={{ fontWeight: "bold" }}>
                    <strong style={{ color: "black" }}>Accounts</strong>
                  </Accordion.Header>
                  {accountsOptions}
                  {/* <Accordion.Body>
              <Link
                to="dailyExpense"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <GiExpense size="20" /> Daily Expense
              </Link>
            </Accordion.Body>
            <Accordion.Body>
              <Link
                to="/salaryExpense"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <RiCurrencyFill size="20" /> Salary Expense
              </Link>
            </Accordion.Body>
            <Accordion.Body>
              <Link
                to="/incomeScreen"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <RiCurrencyFill size="20" /> Income Screen
              </Link>
            </Accordion.Body>

            <Accordion.Body>
              <Link
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: "bold",
                }}
                to=""
              >
                {" "}
                <IoPeopleSharp size="20" /> Human Resource
              </Link>
            </Accordion.Body> */}

                  <Accordion.Item></Accordion.Item>
                  {userInfo && userInfo.userType === "admin" ? (
                    <Card.Text>
                      <Card.Text className="my-3 ms-3 pb-4">
                        <MdPhonelinkSetup className="mb-1" size="20" />
                        <Link
                          to="/MasterSetup"
                          style={{
                            textDecoration: "none",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          Master Setup
                        </Link>
                      </Card.Text>
                    </Card.Text>
                  ) : null}
                </Accordion.Item>
              </Accordion>
            </Sidebar>

            {userInfo && (
              <>
                <main style={{ display: "flex", padding: 10 }}>
                  <div>
                    <button
                      className="sb-button rounded border-0 d-flex align-items-center"
                      onClick={() => setToggled(!toggled)}
                      variant="outline-secondary"
                    >
                      <TfiMenu size="30" />
                    </button>
                  </div>
                </main>
              </>
            )}
          </div>
          <Navbar.Brand>
            {" "}
            {/* <h3 className='fw-bold'></h3> */}
            <a>
              <img
                style={{ maxWidth: "100px", maxHeight: "50px" }}
                src="/img/logo.png"
              ></img>
            </a>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Nav className="ms-auto">
            {userInfo ? (
              <Dropdown as={ButtonGroup} drop="">
                <Button variant="outline-none" className="fw-bold">
                  <FaUser className="me-2 mb-1" size="18" />
                  {userInfo.userName}
                </Button>
                <Dropdown.Toggle
                  split
                  variant="outline-none"
                  id="dropdown-split-basic"
                ></Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={logoutHandler}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Nav.Link href="/login">Login</Nav.Link>
            )}
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
